import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, Params, Router, RouterModule } from '@angular/router';
import { TranslocoModule, provideTranslocoScope } from '@jsverse/transloco';
import { SubscriptionProductService } from '@rma/billing/subscription-plans/public/api-subscription-features';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { RmaLetModule } from '@rma/generic/ui/let';
import { StaticAssetPipe } from '@rma/generic/util/pipes/static-asset-url';
import { getCurrentRoute, setRedirectUrl } from '@rma/generic/util/router-utils';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'rma-teams-callout-banner',
  imports: [CommonModule, MatButtonModule, TranslocoModule, StaticAssetPipe, RmaLetModule, RouterModule, RmaIconComponent],
  providers: [provideTranslocoScope('teamsBanner')],
  templateUrl: './teams-callout-banner.component.html',
  styleUrls: ['./teams-callout-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamsCalloutBannerComponent implements OnInit {
  @Input() name: string | null;
  @Input() cardFooter: boolean;

  protected readonly teamsQueryParams$: Observable<Params>;

  public isDismissed = false;
  public teamImage = 'assets/images/promotion-banner/teams-callout/team-banner.png';
  public teamUrl = 'https://go.ratemyagent.com/teams-contact-us';

  public trialPeriodDays$: Observable<number>;
  public showContactForm$: Observable<boolean>;

  constructor(
    private readonly subscriptionProductService: SubscriptionProductService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.teamsQueryParams$ = this.route.queryParams.pipe(
      map((queryParams) => ({ source: 'teams', ...setRedirectUrl(getCurrentRoute(this.router), queryParams) })),
    );
  }

  ngOnInit(): void {
    this.trialPeriodDays$ = this.subscriptionProductService.teamAvailableTrialDays$;

    this.showContactForm$ = this.subscriptionProductService.teamSubscriptionProducts$.pipe(
      map((x) => !!x.filter((y) => y.ContactForPriceInformation === true).length),
    );
  }

  onClose() {
    this.isDismissed = true;
  }
}
